import React from 'react';

export interface LoadingBannerProps {
  progress: string;
}

export const LoadingBanner: React.FC<LoadingBannerProps> = ({ progress }) => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg px-3 py-2">
      <div className="flex items-center gap-2">
        <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-600 dark:border-blue-400 border-t-transparent"></div>
        <p className="text-sm text-blue-700 dark:text-blue-300">
          {progress || 'Fetching additional usage data...'}
        </p>
      </div>
    </div>
  );
};

export interface PartialErrorBannerProps {
  error: string;
  onRetry: () => void;
}

export const PartialErrorBanner: React.FC<PartialErrorBannerProps> = ({ error, onRetry }) => {
  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-amber-800 dark:text-amber-200">
          Partial data is shown. Some requests failed: {error}
        </p>
        <button
          onClick={onRetry}
          className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium rounded transition-colors"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export interface ReloadingOverlayProps {
  progress: string;
}

export const ReloadingOverlay: React.FC<ReloadingOverlayProps> = ({ progress }) => {
  return (
    <div className="fixed top-3 left-1/2 z-50 w-[min(92vw,48rem)] -translate-x-1/2">
      <div className="rounded-lg border border-slate-200 bg-white/95 px-3 py-2.5 shadow-xl backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 sm:px-4">
        <div className="flex items-center gap-3">
          <div className="h-4 w-4 flex-shrink-0 animate-spin rounded-full border-2 border-emerald-600 border-t-transparent dark:border-emerald-400" />
          <p className="truncate text-sm font-medium text-slate-800 dark:text-slate-200">
            {progress || 'Refreshing usage data...'}
          </p>
        </div>
      </div>
    </div>
  );
};
